import React, {useEffect, useState} from "react";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import {IconButton} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import CustomDialogTitle from "../custom-dialog-title";

const $ = window.jQuery;

const FullscreenDialog = ({
  open = false,
  title = null,
  titleProps = {},
  onClose = null,
  className = "",
  onEnter,
  onExit,
  children,
  ariaLabel,
  ...props
}) => {
  const {t} = useTranslation();

  const messages = useSelector(state => state?.spinner?.messages ?? []);

  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    if (open) {
      setIsFullscreen(false);
    }
  }, [open]);

  return (
    <Dialog
      {...props}
      open={open}
      maxWidth={isFullscreen ? false : "lg"}
      fullWidth
      onClose={onClose}
      className={`components__dialog components__dialog--fullscreen ${className} `}
      disableEscapeKeyDown={messages.length > 0}
      slotProps={{
        paper: {
          sx: {
            margin: "32px !important",
            height: "calc(100% - 64px) !important",
            width: "calc(100% - 64px) !important"
          },
          "aria-label": ariaLabel ? ariaLabel : null
        },
        transition: {
          onEnter: () => {
            document.body.classList.add("body--hidden-scrollbar");

            if (onEnter) onEnter();
          },
          onExit: () => {
            if ($(".components__dialog").length <= 1) {
              document.body.classList.remove("body--hidden-scrollbar");
            }

            if (onExit) onExit();
          }
        }
      }}
    >
      <CustomDialogTitle
        {...titleProps}
        onClose={onClose}
        className="components__dialog__header--fullscreen"
        rightActions={
          <IconButton
            aria-label={
              isFullscreen ? t("components.fullscreenDialog.exitButton") : t("components.fullscreenDialog.enterButton")
            }
            sx={{
              padding: "4px"
            }}
            onClick={() => setIsFullscreen(!isFullscreen)}
          >
            {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>
        }
      >
        {title}
      </CustomDialogTitle>
      {children}
    </Dialog>
  );
};

export default FullscreenDialog;
